import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'animate.css';
import "react-image-gallery/styles/scss/image-gallery.scss";



import "react-image-gallery/styles/css/image-gallery.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'bootstrap/dist/js/bootstrap.bundle.js' ; 
import '@fortawesome/fontawesome-free/css/all.min.css' ; 
import 'slick-carousel/slick/slick.css';
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import 'lightbox.js-react/dist/index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
